type PageInfo = {
  iconName: string;
  title: string;
  tag?: string;
};

/**
 * Get page icon name and title based on pathname
 */
export function getPageInfo(pathname: string): PageInfo {
  // Dashboard
  if (pathname.includes('/dashboard/awaiting-actions')) {
    return { iconName: 'House', title: 'Dashboard' };
  }
  if (pathname.includes('/dashboard/logs')) {
    return { iconName: 'ClipboardText', title: 'Audit Logs' };
  }
  if (pathname.includes('/dashboard')) {
    return { iconName: 'Factory', title: 'Dashboard' };
  }

  // SCM
  if (pathname.includes('/scm/storage-provider')) {
    return { iconName: 'Warehouse', title: 'Storage Providers' };
  }
  if (pathname.includes('/scm/purchase-orders')) {
    return { iconName: 'Receipt', title: 'Purchase Orders' };
  }
  if (pathname.includes('/scm/supplier')) {
    return { iconName: 'Factory', title: 'Suppliers' };
  }
  if (pathname.includes('/scm/work-orders')) {
    return { iconName: 'GearFine', title: 'Work Orders' };
  }
  if (pathname.includes('/scm/shipments')) {
    return { iconName: 'Truck', title: 'Shipments', tag: 'BETA' };
  }
  if (pathname.includes('/scm/restock')) {
    return { iconName: 'ChartLineUp', title: 'Forecast' };
  }
  if (pathname.includes('/scm')) {
    return { iconName: 'Kanban', title: 'SCM' };
  }

  // Catalogs
  if (pathname.includes('/catalogs/classification-guide')) {
    return { iconName: 'TreeStructure', title: 'Classification Guide' };
  }
  if (pathname.includes('/catalogs/components')) {
    return { iconName: 'PuzzlePiece', title: 'Components' };
  }
  if (pathname.includes('/catalogs/attributes')) {
    return { iconName: 'CubeTransparent', title: 'Carton Configuration' };
  }
  if (pathname.includes('/catalogs')) {
    return { iconName: 'Barcode', title: 'Products' };
  }

  // Data Studio
  if (pathname.includes('/data-studio/manifest-reports')) {
    return { iconName: 'Files', title: 'Manifest Report' };
  }
  if (pathname.includes('/analytics') || pathname.includes('/data-studio')) {
    return { iconName: 'ProjectorScreenChart', title: 'Analytics' };
  }

  // Orders & Shipments. Orders shows a box, as in the prototype.
  if (pathname.includes('/orders')) {
    return { iconName: 'ShoppingCart', title: 'Orders' };
  }
  if (pathname.includes('/shipment')) {
    return { iconName: 'Truck', title: 'Shipments' };
  }

  // CRM
  if (pathname.includes('/crm') || pathname.includes('/customers')) {
    return { iconName: 'UserCircle', title: 'CRM' };
  }

  // B2B orders share the Orders title; the switch beside it tells them apart.
  if (pathname.includes('/wholesale/invoices')) {
    return { iconName: 'ShoppingCart', title: 'Orders' };
  }

  // Wholesale
  if (pathname.includes('/wholesale')) {
    return { iconName: 'Storefront', title: 'Wholesale' };
  }

  // Other pages
  if (pathname.includes('/settings')) {
    return { iconName: 'Gear', title: 'Settings' };
  }
  if (pathname.includes('/notifications')) {
    return { iconName: 'Bell', title: 'Notifications' };
  }

  // Default — extract from URL segment
  const segment = pathname.replace(/^\/app\//, '').split('/')[0] || 'dashboard';
  const title = segment.replace(/-/g, ' ');
  return {
    iconName: 'List',
    title: title.charAt(0).toUpperCase() + title.slice(1),
  };
}
